import { dataDiamondSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconDiamondSolid = /*#__PURE__*/createIcon(dataDiamondSolid)
export default IconDiamondSolid
